import { Flex, Tabs } from "antd";
import "./styles.less"
import PaymentOrderdTab from "./tabs/PaymentOrdersTab";
import OrdersTab from "./tabs/OrdersTab";

export default function OrdersPage () {

const tabsConfig = [
        {
            label: `Приказы по выплатам`,
            key: "1",
            children: <PaymentOrderdTab/>,
        },
        {
            label: `Все приказы`,
            key: "2",
            children: <OrdersTab/>,
        }
    ]

    return (
        <Flex className="orders-page">
            <Tabs style={{width: "100%"}}
                      defaultActiveKey="1"
        type="card"
                      items={tabsConfig}
                />
        </Flex>
    )
}